module.exports = __webpack_public_path__ + "img/bad-credit-blue.3328e1cb.svg";